import React from "react";
import { Dialog, Transition } from "@headlessui/react";
import { Fragment, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Modal from "components/modal/Modal";
import SecondaryButton from "ui/buttons/SecondaryButton";
import LoadingPrimaryButton from "ui/buttons/LoadingPrimaryButton";
import PrimaryButton from "ui/buttons/PrimaryButton";
import customAxios from "middleware/customAxios";

export default function ProductDelete({ setOpen }) {
  let navigate = useNavigate();
  const { id } = useParams();
  const [showModal, setShowModal] = useState(true);
  const [loading, setLoading] = useState(false);

  let modalChange = () => {
    console.log("hit");
    setShowModal(false);
    navigate("/products/all");
  };

  React.useEffect(() => {
    setShowModal(true);
  }, []);

  const handleDelete = () => {
    if (!id) return;
    setLoading(true);
    customAxios
      .delete("/admin/product/" + id)
      .then(() => {
        modalChange();
      })
      .catch((error) => {
        const msg =
          error.response?.data?.message ||
          error.message ||
          "Failed to delete product. Please try again.";
        alert(msg);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <div className="  ">
      <Modal
        show={showModal}
        setShowModal={modalChange}
        heading="Delete Product"
        subHeading="Are you sure you want to delete this Product?"
      >
        <div class="bg-gray-50 sticky bottom-0 w-full px-4 py-3 md:flex grid grid-cols-2 gap-3  justify-end items-center flex-row space-x-3">
          <SecondaryButton onClick={modalChange} title={"Cancel"} />

          {loading ? (
            <LoadingPrimaryButton title={"Deleting..."} />
          ) : (
            <PrimaryButton title={"Delete"} onClick={handleDelete} />
          )}
        </div>
      </Modal>
    </div>
  );
}
